import { render, staticRenderFns } from "./TabChannels.vue?vue&type=template&id=ae3ea2b6"
import script from "./TabChannels.vue?vue&type=script&lang=js"
export * from "./TabChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports